(function() {
  define('tlhServicesConfirmModal',['angular', 'angularSanitize', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('tlhServicesConfirmModal', ['ngSanitize', 'ngAnimate', 'ui.bootstrap']).factory('TlhConfirmModalService', [
      '$uibModal', function($uibModal) {
        var factory;
        factory = {};
        factory.open = function(body) {
          return $uibModal.open({
            templateUrl: '/assets/lib/angular/tlh/services/confirmModal.html',
            resolve: {
              data: {
                body: body
              }
            },
            controller: [
              '$scope', '$uibModalInstance', 'data', function($scope, $uibModalInstance, data) {
                $scope.data = data || {};
                $scope.ok = function() {
                  var result;
                  result = {
                    confirm: true
                  };
                  return $uibModalInstance.close(result);
                };
                return $scope.cancel = function() {
                  return $uibModalInstance.dismiss('cancel');
                };
              }
            ]
          });
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=confirmModal.js.map
;
